const e = "styles-module__container___FyQcH", s = "styles-module__description___Kfz7Q", t = "styles-module__truncated___-F-05", _ = {
  container: e,
  "room-description": "styles-module__room-description___jC2-l",
  description: s,
  truncated: t,
  "view-more-less": "styles-module__view-more-less___1pUfW"
};
export {
  e as container,
  _ as default,
  s as description,
  t as truncated
};
